<script setup lang="ts">
import { refThrottled, useElementSize } from "@vueuse/core"

const { sortedContents, onDetailViewMounted, onDetailViewUnmounted, onUpdatedViewModeSettings } = useDetailView()
const { state: viewModeState } = useViewMode()
const { currentRootFolder } = useNavigation()

const container = ref<HTMLDivElement>()
const { width } = useElementSize(container)
const throttledWidth = refThrottled(width, 1000 / 30)

const numColumns = computed(() => {
  const maxColumnWidth = viewModeState.value.current.detailView.maxColumnWidth
  if (maxColumnWidth < 100) {
    console.warn("Column width invalid or container missing")
    return 0
  }
  return Math.ceil(throttledWidth.value / maxColumnWidth)
})

onMounted(() => onDetailViewMounted())
onUnmounted(() => onDetailViewUnmounted())
watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <collection-scroll-container vertical>
    <div class="spacer" />
    <div class="notes-container">
      <collection-folder-notes
        v-if="currentRootFolder"
        :key="currentRootFolder.id"
        :folder="currentRootFolder.asStatic()"
      />
    </div>
    <div
      ref="container"
      class="grid grid-cols-2 gap-0.5 overflow-x-hidden p-0.5 pt-0"
      :style="{
        gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))`,
      }"
    >
      <collection-detail-file
        v-for="file in sortedContents"
        :key="file.id"
        :file-id="file.id"
      />
    </div>
  </collection-scroll-container>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.spacer
  @apply pointer-events-none w-full h-[#{$nav-h-default}]

.notes-container
  @apply px-[#{$page-icon-p-main}] pt-[#{$page-icon-p-main}]
</style>
